import React 				from 'react';
import PropTypes 		from 'prop-types';
import BLComponent 	from '../core/_BLComponent.jsx';

export default class PartListingItem extends BLComponent {
	constructor(props) {
		super(props);

		this.state = {
		}
	}

	render() {
		const {classes = '', data} = this.props;
		let selectedColor = blapp.color.get(data.color);

		if(selectedColor == null) {
			selectedColor = blapp.color.get(0);
		}

		return (
			<article className={"product-listing-item part-listing-item " + classes}>
				<div className="product-listing-item__internal part-listing-item__internal">
					<div className="product-listing-item__image part-listing-item__image">
						<img src={data.image} className="part-listing-item__image-item"/>
						<div className="l-hide--small l-margin-top--sm text--center">{data.itemNumber}</div>
					</div>
					<div className="product-listing-item__info part-listing-item__info">
						<div className="part-listing-item__details">
							<strong className="product-listing-item__name">{data.name}</strong>
							<div className="l-hide--small l-flex l-center l-margin-top">
								<i className="color-swatch l-margin-right--sm" style={{background: `#${selectedColor.strColorHex}`}}/>{selectedColor.strColorName}
							</div>
						</div>
						<div className="product-listing-item__number l-hide--desktop">Item no: {data.itemNumber}</div>
						<div className="product-listing-item__color l-hide--desktop l-flex l-center l-margin-top l-margin-bottom">
							<i className="color-swatch l-margin-right--sm" style={{background: `#${selectedColor.strColorHex}`}}/>{selectedColor.strColorName}
						</div>
						<div className="part-listing-item__qty"><span className="l-hide--desktop l-margin-right--sm">Quantity:</span><strong>{data.qty}</strong></div>
					</div>
				</div>
			</article>
		);
	}
}

PartListingItem.propTypes = {
		classes: PropTypes.string
	,	data: PropTypes.shape({
				link: PropTypes.string
			,	image: PropTypes.string.isRequired
			,	name: PropTypes.string.isRequired
			, itemNumber: PropTypes.string
			, qty: PropTypes.number
			, color: PropTypes.number
		}).isRequired
}